import axios from 'axios'
const uri = 'descargar-copion/php/api/'
const post = (url, data) => {
	return axios.post(uri + url, data)
}

const get = (url) => {
	return axios.get(uri + url)
}
export default {
	getEmisoras () {
		return get('listadoEmisoras.php')
	},
	getListadoProgramaciones () {
		return new Promise((resolve, reject) => {
			get('get-listado-programaciones.php')
				.then(res => {
					const listado = res.data.listado

					for (let i = 0; i < listado.length; i++) {
						listado[i].fecha = (listado[i].fecha) ? new Date(listado[i].fecha) : null

						if (listado[i].diferida) {
							listado[i].diferida.fecha = new Date(listado[i].diferida.fecha)
						}

						if (listado[i].periodica) {
							listado[i].periodica.fechaIni = new Date(listado[i].periodica.fechaIni)
							listado[i].periodica.fechaFin = (listado[i].periodica.fechaFin) ? new Date(listado[i].periodica.fechaFin) : null
							listado[i].periodica.dias = listado[i].periodica.dias.toString()
						}
					}

					resolve(listado)
				})
				.catch(reject)
		})
	},
	getListadoDescargas () {
		return get('get-descargas.php')
	},
	programar (form) {
		const datos = {
			ID_programacion: form.ID_programacion,
			fecha: (form.fecha) ? Math.floor(form.fecha.getTime() / 1000) : null,
			horaIni: form.horaIni,
			horaFin: form.horaFin,
			avisar: (typeof form.avisar === 'boolean') ? form.avisar : true,
			titulo: form.titulo,
			publica: (typeof form.publica === 'boolean') ? form.publica : false,
			diferida: null,
			periodica: null,
			EmisoraID: form.EmisoraID
		}

		if (form.diferida) {
			datos.periodica = null
			datos.diferida = {
				fecha: Math.floor(form.diferida.fecha.getTime() / 1000),
				hora: form.diferida.hora
			}
		} else if (form.periodica) {
			datos.diferida = null
			datos.fecha = null
			datos.periodica = {
				fechaIni: Math.floor(form.periodica.fechaIni.getTime() / 1000),
				fechaFin: (form.periodica.fechaFin) ? Math.floor(form.periodica.fechaFin.getTime() / 1000) : null,
				hora: form.periodica.hora,
				dias: form.periodica.dias
			}
		}

		return post('programar.php', datos)
	},
	eliminarProgramacion (idProgramacion) {
		const datos = {
			ID_programacion: idProgramacion
		}

		return post('del-programacion.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/descargar-copion/vue/api.js